import { AppThunk } from '../../../store/rootReducer';
import {
  hasSuggestionsToAssessSelector,
  codesToAddToAssessSelector,
  codesToRemoveToAssessSelector,
} from '../selectors/auto-labels.selectors';
import { displayNotification } from '../../../shared/notification/display-notification';
import * as autoLabelsActions from '../actions/auto-labels.actions';

export const displayAutoLabelsToAssess =
  (): AppThunk<boolean> => (dispatch, getState) => {
    const hasSuggestionsToAssess = hasSuggestionsToAssessSelector(getState());
    const codesToAddToAssess = codesToAddToAssessSelector(getState());
    const codesToRemoveToAssess = codesToRemoveToAssessSelector(getState());
    if (hasSuggestionsToAssess) {
      dispatch(
        autoLabelsActions.setAutoLabels({
          labelsToAdd: codesToAddToAssess.map((code) => ({
            code,
            status: false,
          })),
          labelsToRemove: codesToRemoveToAssess.map((code) => ({
            code,
            status: false,
          })),
          meta: { history: false },
        }),
      );
      displayNotification({
        title: 'Warning',
        description: 'Please assess label suggestions first',
        status: 'warning',
      });
      return true;
    } else {
      return false;
    }
  };
